import { render, staticRenderFns } from "./Corps.vue?vue&type=template&id=08b0dfbf&scoped=true"
import script from "./Corps.vue?vue&type=script&lang=js"
export * from "./Corps.vue?vue&type=script&lang=js"
import style0 from "./Corps.vue?vue&type=style&index=0&id=08b0dfbf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0dfbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b0dfbf')) {
      api.createRecord('08b0dfbf', component.options)
    } else {
      api.reload('08b0dfbf', component.options)
    }
    module.hot.accept("./Corps.vue?vue&type=template&id=08b0dfbf&scoped=true", function () {
      api.rerender('08b0dfbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Corps.vue"
export default component.exports